// Libraries
import {
  Component,
  ElementRef,
  Output,
  EventEmitter,
  HostBinding,
} from '@angular/core';
import {
  state,
  animate,
  style,
  trigger,
  transition
} from '@angular/animations';

/**
 * `ItemBodyComponent` implements toggle functionality for item body element.
 */
@Component({
  selector: 'wp-item-body',
  template: '<ng-content></ng-content>',
  animations: [
    trigger(
      'collapse',
      [
        state('true', style(
          {
            height: '0px',
            overflow: 'hidden'
          }
        )),
        state('false', style({ height: '*' })),
        transition('1 => 0', [
          style({ overflow: 'hidden' }),
          animate('200ms ease-in')
        ]),
        transition('0 => 1', [
          style({ overflow: 'hidden' }),
          animate('200ms ease-out')
        ])
      ]
    )
  ]
})
export class ItemBodyComponent {
  // Public properties
  /**
   * Open event
   */
  @Output()
  openItem = new EventEmitter();
  /**
   * Close event
   */
  @Output()
  closeItem = new EventEmitter();
  /**
   * Toggle event
   */
  @Output()
  toggleItem = new EventEmitter();
  /**
   * Handles collapse event
   */
  @HostBinding('@collapse') isCollapsed = false;
  @HostBinding('style.display') display = 'block';

  /**
   * Creates an instance of ItemBodyComponent.
   */
  constructor(
    private element: ElementRef
  ) {
  }

  // Public methods
  /**
   * Open item.
   */
  open() {
    this.isCollapsed = false;
    // Emit event
    this.openItem.emit(this);
  }

  /**
   * Close item
   */
  close() {
    this.isCollapsed = true;
    // Emit event
    this.closeItem.emit(this);
  }

  /**
   * Toggle item.
   */
  toggle() {
    // Toggle current element
    if (this.isCollapsed) {
      this.open();
    } else {
      this.close();
    }
    this.toggleItem.emit(this);
  }
}
